import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import { PixUpgradeLock_OfferLockDataFragment } from './__generated__/pix-upgrade-lock.graphql'
import styles from './pix-upgrade-lock.module.scss'
import { PixUpgradeLockContent } from './pix-upgrade-lock-content'

export interface PixUpgradeLockProps {
  offerLockData: PixUpgradeLock_OfferLockDataFragment
}

export function PixUpgradeLock({ offerLockData }: PixUpgradeLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <PixUpgradeLockContent offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles.pixUpgradeLockPaywall}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return (
        <ModalLock addHeader={false} offerLockBody={offerLockData.body}>
          {content}
        </ModalLock>
      )
    default:
      return null
  }
}

PixUpgradeLock.fragments = {
  offerLockData: gql`
    fragment PixUpgradeLock_offerLockData on OfferLockData {
      ...PixUpgradeLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${PixUpgradeLockContent.fragments.offerLockData}
  `,
}
